// extracted by mini-css-extract-plugin
module.exports = {"order":"MobileOrderCard_order_3wtZO","title":"MobileOrderCard_title_3nPol","date":"MobileOrderCard_date_2runH"};